export default {
    addiction: 'اعتیاد',
    addictionTitle: 'عنوان',
    addictionStatus: 'وضعیت',
    addictions: 'اعتیادها ',
    editAddiction: 'ویرایش اعتیاد',
    addAddiction: 'اعتیاد جدید',
}